import React, { useContext, useMemo } from 'react'
import Modal from 'react-responsive-modal'
import { WebLessonsContext } from '../../../utils/context'
import styles from '../styles.module.scss'
import { AudioComponent, VideoComponent } from '../../../components/LivekitComponents'

const DialogModal = () => {
  
  const {endDialog, activeDialog, participants} = useContext(WebLessonsContext)
  
  const dialogParts = useMemo(() => participants.filter(p => p.sid === activeDialog || p._attributes.position === 'teacher'), [activeDialog, participants])

  const renderPart = (part, index) => (
    
    <div key={index}>
      <User {...part} />
    </div>
  )

  return (
    <Modal
      open={!!activeDialog}
      onClose={endDialog}  
      styles={{modal: {maxWidth: '1200px'}}} 
      center
    >
      <div className={styles.dialogModal}>{dialogParts.map(renderPart)}</div>
    </Modal>
  )
}

const User = ({
  videoTrackPublications,
  audioTrackPublications,
  isLocal,
  _attributes,
  identity,
  setFullScreen,
  isSpeaking
}) => {
  
  const { username, organization, position } = _attributes
  const [videoTrack] = Array.from(videoTrackPublications.values())
  const [audioTrack] = Array.from(audioTrackPublications.values())


  return (
    <div className={styles.user} style={{outline: isSpeaking ? '1px solid #F2DFA4' : ''}}>
      {videoTrack && <VideoComponent {...videoTrack} />}
      {audioTrack && !isLocal && <AudioComponent {...audioTrack}/>}
      <div className={styles.descriptionWrapper}>
        {!!username &&
          <div className={styles.descriptionMain}>
            <p>{username}</p>
          </div>
        }
      </div>
    </div>
  )
}


export default DialogModal